export default __webpack_public_path__ + "static/media/yen-2-text.fb890636.jpg";